import { all, call } from 'redux-saga/effects';
import { paymentSagas } from './payment/payment.sagas';

function* rootSaga() {
  yield all([
    call(paymentSagas),
  ]);
}

export default rootSaga;
